// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"1a061241","453":"77aef9b5"}[chunkId] + ".chunk.js";
};